export const actionTypes = {
  FILTER_ADD: 'FILTER_ADD',
  FILTER_REMOVE: 'FILTER_REMOVE',
  UPDATE_STATUS: 'UPDATE_STATUS',
  UPDATE_RESULTS: 'UPDATE_RESULTS',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  UPDATE_FILTER: 'UPDATE_FILTER',
  CLEAR_FILTERS: 'ClEAR_FILTERS',
  INIT_STORE: 'INIT_STORE',
  UPDATE_PAGE: 'UPDATE_PAGE',
  UPDATE_SORT: 'UPDATE_SORT',
  SEARCH: 'SEARCH',
  DEBUG: 'DEBUG',
  MERGE_STORE: 'MERGE_STORE'
};

export const LAZY_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

export const initialState = {
  hits: [],
  isDebugMode: false,
  settings: {
    openFilterLimit: {"bodylab_nl":7,"bodylab":7,"bodylab_ch":7,"gymqueen_nl":4,"gymqueen":4,"de_de":8,"at":8,"ch_de":8},
    openFilterDefaultLimit: 6,
    layout: {
      default: 'list',
      'vomachterhof': 'list',
    }
  },
  sorting: [
    {
      label: 'Relevanz',
      value: 'score_desc',
      default: true
    },
    {
      label: 'Niedrigster Preis',
      value: 'price_asc',
      default: false
    },
    {
      label: 'Höchster Preis',
      value: 'price_desc',
      default: false
    },
    {
      label: 'Neuheiten',
      value: 'new_arrivals_desc',
      default: false
    },
    {
      label: 'Bestsellers',
      value: 'score_top_seller_desc',
      default: false
    },
    {
      label: 'Kundenbewertungen',
      value: 'user_rating_desc',
      default: false
    },
    {
      label: 'Angebote',
      value: 'discount_desc',
      default: false
    }
  ],
  status: undefined,
  values: {},
  perPage: 48,
  viewTypes: ['list', 'grid']
};

export const ALLOWED_ICON_VALUES = {
  'Low Carb': 'Low Carb',
  Vegan: 'Vegan',
  Glutenfrei: 'Gluten free',
  Laktosefrei: 'Lactose free',
  Bio: 'Biological',
  Zuckerfrei: 'Sugar free',
  '100% natürliche Zutaten': 'Only natural ingredients',
  'Ohne Zuckerzusatz': 'No added sugar',
  'Frei von künstlichen Konservierungsstoffen': 'Free of artificial preservatives',
  'Frei von künstlichen Farbstoffen': 'Free of coloring agents',
  'Frei von künstlichen Geschmacksverstärkern': 'Free of artificial flavors',
  Gentechnikfrei: 'GMO-free',
  'Ohne Süßungsmittel': 'Without sweeteners',
  'Zink für Haut, Haare und Nägel': 'Zinc for skin hair and nails',
  'Vitamin C für Kollagenbildung': 'Vitamin C for collagen formation',
  'Unterstützt die Regeneration': 'Supports regeneration',
  'Unterstützt den Fettstoffwechsel': 'Supports fat metabolism',
  'Mit Honig verfeinert': 'Finished with honey',
  'Ideal für Clean Baking': 'Ideal for clean baking',
  'Hochwertige Proteine': 'High quality proteins',
  'Gute Sättigung': 'Good saturation',
  Fettarm: 'Low fat'
};

export const URLS = {
  skin: '/skin/frontend/vitafy/default/',
  bodylab: '/skin/frontend/vitafy/bodylab/'
};

/**
 * maps the store code to a country code
 *
 * @see getLocale() in /common/helpers
 */
export const STORE_CODE_LOCALE = {
  bodylab_nl: 'nl_NL',
  gymqueen_nl: 'nl_NL',
};
